module.exports = __webpack_public_path__ + "img/bbl_i2.6f61031e.png";